<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1"> مشاهده QR </v-tab>

            <v-tab> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-appointment v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
              <Tariffs :id_qr="info.id" :qrtype="'appointment'" />
          </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <v-row justify="center" no-gutters>
                <v-col class="pb-2 px-2" cols="12">
                  <p>ساخت کیوآر</p>
                </v-col>
                <v-col class="pb-2 px-2 rowinfo" cols="12" md="6">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 2"
                    :error-messages="errors.title"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام مجموعه"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام مجموعه"
                  />
                </v-col>
                <v-col class="pb-2 px-2 rowinfo" cols="12" md="6">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 2"
                    :error-messages="errors.identifier"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </v-col>
              </v-row>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >وارد کردن اطلاعات</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <v-card-actions
                class="justify-space-between mb-4 flex-column flex-md-row"
              >
                <div class="rowinfo">
                  <v-btn
                    :disabled="e6 > 2"
                    color="third"
                    outlined
                    @click="clearDefaults"
                  >
                    <v-icon class="me-2">mdi-delete</v-icon>
                    حذف اطلاعات پیشفرض
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-clearDefaults`"
                    label="حذف اطلاعات پیش‌فرض"
                    :service-name="serviceName"
                    :help-data="helpData"
                  />
                </div>

                <v-switch
                  v-model="cardTexts.appointments.onlineShop"
                  class="mt-2 ma-md-0"
                  dense
                  hide-details
                  inset
                  label="رزرو آنلاین"
                />
              </v-card-actions>
                  <div class="mb-4 x-mx-3">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading"
                      @click="qrUpdate(true);
                      if(!!cardTexts?.appointments?.onlineShop)
                        e6=3;
                    if(!cardTexts?.appointments?.onlineShop)
                        goTo('qr/list')" 
                    />
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step
              v-if="cardTexts?.appointments?.onlineShop"
              :complete="e6 > 3"
              class="px-0 px-md-4"
              step="3"
            >
              تنظیمات رزرو نوبت
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
              <qr-appointment-manager
                ref="appointmentSetting"
                :qr-id="createdId"
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 2" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading" @click="updateShopSettings" />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :visit-name="cardTexts.visitName"
              @close="showDialog = false"
              :qr_id="info.qrId"
            :is-qrlink="['qrlink','clickyarseo'].includes(info?.type?.toLowerCase())"

            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ViewMenu from "@/view/pages/businessPage/components/view/viewMenu";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import { Bus } from "@/main";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake";
import { mapActions } from "vuex";
import ViewAppointment from "@/view/pages/businessPage/components/view/viewAppointment.vue";
import QrAppointmentManager from "@/view/pages/otherQrTypes/appointment/cm/qrAppointmentManager.vue";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "createAppointment",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrAppointmentManager,
    ViewAppointment,
    QrCodeMake,
    QrCustomize,
    DownloadFileWithApi,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    ViewMenu,
    QrMaker,
    Tariffs,
    AtomSpinner
  },

  data: () => ({
    isAutoSaving: false, 
    AutoSave:false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "create-appointment",
    cardTexts: {
      banner: {
        gallery: [
          {
            name: "گالری عکس",
            images: [
              {
                name: "بنر",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17477,
              },
              {
                name: "بنر (2)",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17472,
              },
            ],
          },
        ],
      },
      appointments: {
        title: "نوبت‌ها",
        description: "",
        sectionColor: {
          backGround: "",
          text: "#000",
        },
        items: [],
        onlineShop: true,
      },
      textCards: {
        sectionColor: {
          backGround: "linear-gradient(to bottom , #814992FF, #2F004AFF)",
          text: "#fff",
        },
      },
      extraFields: [
        {
          icon: "",
          name: "",
          value: "",
        },
      ],
      socialMedia: {
        address: [
          {
            label: "آدرس",
            text: "لینک سایت مورد نظر را وارد نمایید",
            pattern: "",
            prefix: "URL",
            url: "qrland.ir",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
          {
            label: "آدرس",
            text: "لینک سایت مورد نظر را وارد نمایید",
            pattern: "",
            prefix: "URL",
            url: "qr.terminalads.com",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
        ],
        instagram: [
          {
            label: "اینستاگرام",
            text: "نام کاربری خود را وارد نمایید",
            pattern: "https://instagram.com/",
            prefix: "@",
            url: "terminalads",
            img: "/media/socialIcon/40icon/instagram.svg",
            svg: "svgInstagram",
          },
        ],
        whatsapp: [
          {
            label: "واتساپ",
            text: "+989123456789",
            pattern: "wa.me/",
            prefix: "mdi-phone",
            url: "+982191017077",
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          },
        ],
      },
      PicSelector: {
        title: null,
        description: null,
        sectionColor: {
          backGround: "",
          text: "",
        },
        slider: true,
      },
      gallery: [
        {
          name: "گالری عکس0",
          images: [
            {
              name: "گالری تصویر (2)",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17474,
            },
            {
              name: "گالری تصویر",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17476,
            },
            {
              name: "گالری تصویر (3)",
              title: "",
              url: "",
              description: "",
              link: "",
              id: 17475,
            },
          ],
        },
      ],
      VideoGallery: {
        title: "گالری ویدئو",
        description:
          "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئو های زیر را مشاهده فرمایید.",
        sectionColor: {
          backGround: "",
          text: "",
        },
      },
      video_gallery: [
        {
          name: "آموزشی",
          images: [
            {
              name: null,
              title: "",
              file_link:
                "https://www.aparat.com/video/video/embed/videohash/hsjuxw1/vt/frame",
              description: "",
              link: "",
              id: 154,
            },
          ],
        },
      ],
      FeedBack: {
        title: "بازخورد شما",
        description:
          "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
        sectionColor: {
          backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
          text: "",
        },
        type: "star",
        items: [],
      },
      WorkSheet: {
        items: {
          saturday: {
            name: "شنبه",
            shift: [
              {
                start: "10:00",
                end: "22:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          sunday: {
            name: "یکشنبه",
            shift: [
              {
                start: "10:00",
                end: "22:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          monday: {
            name: "دوشنبه",
            shift: [
              {
                start: "10:00",
                end: "22:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          tuesday: {
            name: "سه‌شنبه",
            shift: [
              {
                start: "10:00",
                end: "22:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          wednesday: {
            name: "چهارشنبه",
            shift: [
              {
                start: "10:00",
                end: "00:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          thursday: {
            name: "پنجشنبه",
            shift: [
              {
                start: "10:00",
                end: "00:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
          friday: {
            name: "جمعه",
            shift: [
              {
                start: "10:00",
                end: "00:00",
              },
              {},
            ],
            start: "08:00:00",
            end: "22:00:00",
          },
        },
      },
      visitName: "",
      organizationName: "نوبت دهی آنلاین",
      subOrgan: "زمان خود را به راحتی مدیریت کنید.",
      userName: "",
      workField: "",
      phoneNumber: [
        {
          number: "09999903535",
        },
        {
          number: "02191017077",
        },
        {
          number: "90007425",
        },
      ],
      companyNumber: "02191017077",
      email: "info@qrland.ir",
      fax: "02191016066",
      location:
        "تهران، خیابان شریعتی ، بعد از پل سید خندان\nبن بست خندان ، پلاک 6 ، واحد 3",
      city: "",
      codePostal: "1541946815",
      province: "",
      country: "",
      website: "www.terminalads.com",
      aboutUs:
        "برای دریافت نوبت یا دریافت مشاوره کافی است\nبه لیست نوبت ها مراجعه در سایت مراجعه کنید\nو پس از انتخاب زمان مورد نظر نوبت اینترنتی بگیرید.\nهمچنین برای دریافت اطلاعات تماس میتوانید به انتهای سایت مراجعه نمایید.",
      copyright: "تمامی حقوق این سایت متعلق به ترمینال تبلیغات می باشد.",
      center: [51.44663997885132, 35.74305387731438],
      coordinates: [51.446682645747444, 35.743053507096036],
      address:
        "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
      pallete: {},
    },
    createdDomain: null,
    createdId: null,
    domainId: null,
    dtUrl: null,
    errors: {},
    e6: 1,
    info: null,
    specialInfo: [
      {
        name: "bannerSelector",
        value: "",
        title: "آپلود بنر",
        subtitle: "",
        icon: "image-area",
        model: "banner",
      },
      // {name: 'Product', value: '', title: 'ایجاد محصول', subtitle: '', icon: 'sign-yield', model: 'product'},
      {
        name: "Appointments",
        value: "",
        title: "مدیریت نوبت ها",
        subtitle: "",
        icon: "ticket-account",
        model: "appointments",
      },
      {
        name: "PicSelector",
        value: "",
        title: "گالری عکس",
        subtitle: "",
        icon: "image-outline",
      },
      {
        name: "VideoGallery",
        value: "",
        title: "گالری ویدئو",
        subtitle: "",
        icon: "video-outline",
      },
      {
        name: "FeedBack",
        value: "",
        title: "بازخورد",
        subtitle: "",
        icon: "reply-outline",
        model: "FeedBack",
      },
      {
        name: "textCards",
        value: "",
        title: "اطلاعات کاربری",
        subtitle: "",
        icon: "account-outline",
      },
      {
        name: "socialMediaIcons",
        value: "",
        title: "افزودن شبکه های اجتماعی",
        subtitle: "",
        icon: "instagram",
        model: "socialMedia",
      },
      {
        name: "WorkSheet",
        value: "",
        title: "تایم کاری",
        subtitle: "",
        icon: "timetable",
        model: "WorkSheet",
      },
    ],
    showDialog: false,
    loading: false,
    qrShow: 1,
    qrDesign: {},
    qrSvgDataUrl: "",
  }),

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.gallery[0].images[0].url = this.imagegallery_1;
    this.cardTexts.gallery[0].images[2].url = this.imagegallery_3;
    this.cardTexts.gallery[0].images[1].url = this.imagegallery_2;
    this.cardTexts.banner.gallery[0].images[0].url = this.imagegallery_4;
    this.cardTexts.banner.gallery[0].images[1].url = this.imagegallery_5;

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  computed: {
    imagegallery_1() {
      return this.$cdnUrl + "/upload/666d5c5bd450e.webp";
    },
    imagegallery_2() {
      return this.$cdnUrl + "/upload/666d5c6579922.webp";
    },
    imagegallery_3() {
      return this.$cdnUrl + "/upload/666d5c5e114c9.webp";
    },
    imagegallery_4() {
      return this.$cdnUrl + "/upload/666d5c6795bd0.webp";
    },
    imagegallery_5() {
      return this.$cdnUrl + "/upload/666d5c56d0173.webp";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;

      let obj = {
        type: "appointment",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.errors = {};
      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdId = data.data.identifier;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.setCreatedQrID(data.data.id);
          this.qrShow = 0;
          this.$toast.success("نوبت دهی با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "appointment");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
        if(final || !this.AutoSave)
          this.$toast.success("کیوآر منو آنلاین شما باموفقیت ویرایش شد.");

          let hs = this.cardTexts.appointments.onlineShop && this.e6 > 2;

          if (final) {
            // this.e6++;
            // this.qrShow = 0;
            // setTimeout(() => {
            //   // this.$refs.qrCanvas.appendCanvas(this.info.link);
            // }, 500);
            // setTimeout(() => {
            //   // this.qrUpdate();
            //   this.qrShow =1;
            // }, 2000);

            // hs && this.goto("qr/list");
          }
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      let name = this.cardTexts.visitName;
      this.cardTexts = {
        banner: {
          gallery: [{ name: "", images: [] }],
        },
        appointments: {
          title: "نوبت‌ها",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
          onlineShop: true,
        },
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #007376FF, #08004AFF)",
            text: "#fff",
          },
        },
        extraFields: [{ icon: "", name: "", value: "" }],
        socialMedia: {},
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        gallery: [],
        VideoGallery: {
          title: "گالری ویدئو",
          description:
            "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئو های زیر را مشاهده فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [],
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "",
          },
          type: "text",
          items: [],
        },
        WorkSheet: { items: {} },
        visitName: name,
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [],
        companyNumber: "",
        email: "",
        fax: "",
        location: "",
        city: "",
        codePostal: "",
        province: "",
        country: "",
        website: "",
        aboutUs: "",
        copyright: "",
        center: [51.44663997885132, 35.74305387731438],
        coordinates: [51.446682645747444, 35.743053507096036],
        address: "",
        pallete: {},
      };
    },
    updateShopSettings() {
      this.loading = true;

      this.$refs.appointmentSetting.setCartSetting().finally(() => {
        this.setShopNotice();
      });
    },
    setShopNotice() {
      this.$refs.appointmentSetting.setShopNotice().finally(() => {
        this.loading = false;
        this.goto("qr/list");
      });
    },
  },

  beforeDestroy() {
    this.setCreatedQrID(null);
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
.rowinfo {
  display: flex !important;
  flex-direction: row !important;
  gap: 1px !important;
  justify-content: space-evenly !important;
  margin: 0px !important;
}
.contentinfo {
  flex: 1 1 80% !important;
}
.buttoninfo {
  flex: 1 1 12% !important;
}
</style>
